import React from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { DashboardLayout } from './DashboardLayout';
import { DashboardOverview } from './DashboardOverview';
import { ApiKeysPage } from './ApiKeysPage';
import { AnalyticsPage } from './AnalyticsPage';
import { CustomersPage } from './CustomersPage';
import { BillingPage } from './BillingPage';
import { WebhooksPage } from './WebhooksPage';
import { DocumentationPage } from './DocumentationPage';
import { VideoSDKDemo } from './VideoSDKDemo';
import { TemplateApp } from './TemplateApp';

const SettingsPage: React.FC = () => (
  <div className="text-center py-12">
    <h2 className="text-2xl font-bold text-light-text-primary dark:text-dark-text-primary mb-4">
      Account Settings
    </h2>
    <p className="text-light-text-secondary dark:text-dark-text-secondary">
      Coming soon! Manage your account settings and preferences.
    </p>
  </div>
);

export const AppRouter: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    // Path should already include org ID from DashboardLayout
    navigate(path);
  };
  
  // Extract the base path without org ID for currentPage comparison
  const getBasePath = (pathname: string) => {
    const orgIdMatch = pathname.match(/^\/[a-zA-Z0-9_]+(.*)$/);
    return orgIdMatch ? orgIdMatch[1] || '/' : pathname;
  };

  return (
    <DashboardLayout 
      currentPage={getBasePath(location.pathname)}
      onNavigate={handleNavigate}
    >
      <Routes>
        <Route path="/" element={<DashboardOverview />} />
        <Route path="/api-keys" element={<ApiKeysPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/billing" element={<BillingPage />} />
        <Route path="/webhooks" element={<WebhooksPage />} />
        <Route path="/docs" element={<DocumentationPage />} />
        <Route path="/video-sdk" element={<VideoSDKDemo />} />
        <Route path="/templates/*" element={<TemplateApp />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Routes>
    </DashboardLayout>
  );
};